import React from 'react';
import { BlogArticleTemplate } from '../../components/blog/BlogArticleTemplate';
import { implantsCostArticle } from '../../data/blog/implantsCostArticle';
export function ImplantyCostArticle() {
  return <BlogArticleTemplate article={implantsCostArticle} data-id="element-804" data-mp="6lr2lf7cqyem" />;
}